<template>
  <div class="bg-gray-100 py-6" style="height:calc(100vh - 70px)">
    <div class="bg-white overflow-hidden shadow rounded-lg max-w-4xl mx-auto">
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <div
          class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
        >
          <div class="ml-4 mt-2">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Marketing templates
            </h3>
          </div>
          <div class="ml-4 mt-2 flex-shrink-0">
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-4 disabled:opacity-75"
                @click="resyncStatus"
                :disabled="buttonLoaders.isResyncingStatus"
              >
                Resync<span v-if="buttonLoaders.isResyncingStatus">ing</span>
                Status
              </button>
              <button
                type="button"
                class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                @click="createNew('Abandoned')"
              >
                Create new
              </button>
            </span>
          </div>
        </div>
      </div>
      <div>
        <!-- Content goes here -->
        <ul>
          <li v-for="(template, index) of templates" :key="index">
            <a
              href="#"
              class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="grid grid-cols-7">
                  <div
                    class="text-sm leading-5 font-medium text-indigo-600 truncate col-span-2"
                  >
                    {{ template.name }}
                  </div>
                  <div class="col-span-2">
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium "
                      :class="{
                        'bg-yellow-100 text-yellow-800':
                          template.status === 'rejected',
                        'bg-green-100 text-green-800':
                          template.status === 'approved'
                      }"
                    >
                      {{ template.status }}
                    </span>

                    <span
                      v-if="template.status === 'rejected'"
                      class="text-xs text-gray-700"
                      ><p>Reason for rejection:</p>

                      {{ template.reasonForRejection }}
                    </span>
                  </div>
                  <div
                    class="col-span-3 text-gray-700 text-sm whitespace-pre-wrap"
                  >
                    {{ getTemplateMessage(template) }}
                  </div>
                </div>
              </div>
            </a>
          </li>
          <li
            class="text-center text-gray-700 text-sm p-20"
            v-if="templates.length === 0"
          >
            Create a template to start sending marketing messages
          </li>
        </ul>
      </div>
    </div>

    <CreateTemplate v-if="showModal" @close="closeModal" @create="onCreate" />
  </div>
</template>

<script>
import CreateTemplate from "@/components/Marketing/CreateTemplate.vue";

export default {
  name: "MarketingTemplates",
  components: {
    CreateTemplate
  },
  data() {
    return {
      showModal: false,
      currentTemplate: null,
      buttonLoaders: {
        isResyncingStatus: false
      }
    };
  },
  computed: {
    templates() {
      return this.$store.getters["Marketing/getTemplates"];
    }
  },
  created() {
    this.loadTemplates();
  },
  methods: {
    loadTemplates() {
      this.$store.dispatch("Marketing/getTemplates");
    },
    closeModal() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    createNew() {
      this.currentTemplate = null;
      this.openModal();
    },
    async onCreate() {
      this.loadTemplates();
    },
    resyncStatus() {
      this.buttonLoaders.isResyncingStatus = true;
      this.$store
        .dispatch("Marketing/resyncStatus")
        .then(() => {
          return this.loadTemplates();
        })
        .then(() => {
          this.buttonLoaders.isResyncingStatus = false;
        });
    },
    getTemplateMessage(template) {
      let message = template.message;
      if (template && template.variables) {
        for (const variable of template.variables) {
          message = message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return message;
    }
  }
};
</script>

<style lang="scss" scoped></style>
